import React, { useState, useMemo } from 'react';
import { ChromePicker } from 'react-color';
import { OnClickElsewhere } from '../OnClickElsewhere/OnClickElsewhere';
import tinycolor from 'tinycolor2';
import './ColorPicker.pcss';
import classNames from 'classnames';

type Props = {
  color: string;
  onColorChange: (color: string) => any;
  usedInSlideout?: boolean;
  className?: string;
};

export const ColorPicker = (props: Props) => {
  const { onColorChange, color, usedInSlideout, className } = props;
  const [localColor, setLocalColor] = useState(color);
  const [showColorPicker, setShowColorPicker] = useState(false);

  const closeColorPicker = () => {
    if (showColorPicker) {
      setShowColorPicker(false);
      onColorChange(localColor);
    }
  };

  const shadowColor = useMemo(
    () =>
      tinycolor(localColor).getLuminance() > 0.95 ? '#3555f080' : localColor,
    [localColor],
  );

  return (
    <div className={classNames('mm-color-picker', className)}>
      <OnClickElsewhere
        className="mm-color-picker__input-container mm-color-picker__input-container--color"
        handleClick={closeColorPicker}
      >
        <div
          className="mm-color-picker__color-button"
          onClick={() => setShowColorPicker(!showColorPicker)}
        >
          <button
            className={classNames('mm-color-picker__color-button-inner', {
              'mm-color-picker__color-button-inner--slideout': usedInSlideout,
            })}
            style={{
              backgroundColor: localColor,
              boxShadow: !usedInSlideout
                ? `0px 4px 15px ${shadowColor}`
                : 'none',
            }}
          />

          <div
            className={
              usedInSlideout
                ? 'mm-color-picker__color-button-text--slideout'
                : 'mm-color-picker__color-button-text'
            }
          >
            {localColor.replace('#', '').toUpperCase()}
          </div>
        </div>

        {showColorPicker && (
          <ChromePicker
            className="mm-color-picker__color-picker"
            color={localColor}
            disableAlpha={true}
            onChangeComplete={newColor => setLocalColor(newColor.hex)}
          />
        )}
      </OnClickElsewhere>
    </div>
  );
};
